import { useState, useEffect } from 'react'

export function useTypingAnimation(lines: string[], typingSpeed: number) {
  const [displayedLines, setDisplayedLines] = useState<string[]>([])
  const [currentLine, setCurrentLine] = useState(0)
  const [currentChar, setCurrentChar] = useState(0)
  const [isComplete, setIsComplete] = useState(false)

  useEffect(() => {
    if (currentLine >= lines.length) {
      setIsComplete(true)
      return
    }

    const timer = setTimeout(() => {
      if (currentChar < lines[currentLine].length) {
        setDisplayedLines(prev => {
          const newLines = [...prev]
          if (currentLine >= newLines.length) {
            newLines.push('')
          }
          newLines[currentLine] = lines[currentLine].slice(0, currentChar + 1)
          return newLines
        })
        setCurrentChar(prev => prev + 1)
      } else {
        setCurrentLine(prev => prev + 1)
        setCurrentChar(0)
      }
    }, typingSpeed)

    return () => clearTimeout(timer)
  }, [currentLine, currentChar, lines, typingSpeed])

  return { displayedLines, isComplete }
} 